import types from '../../constants';

export function selectUnits(units) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_RUN_UNITS_SELECT, payload: units });
  };
}

export function selectLocation(locationId) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_RUN_LOCATION_SELECT, payload: locationId });
  };
}


export function selectPreviewLocation(locationId) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_RUN_LOCATION_PREVIEW_SELECT, payload: locationId });
  };
}
